import React from 'react'
import { LinearProgress, withStyles } from '@material-ui/core'

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 4,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: theme.colors['grey-100'],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: theme.colors['primary-300'],
  },
}))(LinearProgress)
const Linear = (props) => {
  return <BorderLinearProgress {...props} />
}

export default Linear
